// Iter 83 — Extracted from TradeDoctor.jsx (was at lines ~1454-1483).
// Pure presentation primitive — one of the three Top-Findings tiles
// rendered inside the TradeHealthReportHero. No hooks, no state.
import React from "react";

export function FindingChip({ label, icon, color, title, detail, empty, testid }) {
  const hasContent = !!(title && title.trim());
  return (
    <div
      data-testid={testid}
      className="rounded-sm border p-3 flex flex-col gap-1.5"
      style={{
        borderColor: hasContent
          ? `color-mix(in srgb, ${color} 50%, var(--bt-border))`
          : "var(--bt-border)",
        background: hasContent
          ? `color-mix(in srgb, ${color} 6%, var(--bt-surface))`
          : "var(--bt-surface)",
      }}
    >
      <div
        className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold"
        style={{ color: hasContent ? color : "var(--bt-text-muted)" }}
      >
        {icon}
        {label}
      </div>
      {hasContent ? (
        <p
          className="font-heading text-sm leading-snug"
          style={{ color: "var(--bt-text)" }}
          title={detail || ""}
        >
          {title}
        </p>
      ) : (
        <p className="text-xs text-[var(--bt-text-muted)] italic">{empty}</p>
      )}
    </div>
  );
}
